import React from 'react';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <div className="relative py-24 bg-gate-dark overflow-hidden" data-id="element-21">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gate-teal/5 rounded-full blur-3xl pointer-events-none" data-id="element-22" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-23">
        <h2 className="text-4xl font-bold text-white mb-6" data-id="element-24">
          Start Building with FPGA & ASIC Inference Today
        </h2>
        <p className="text-xl text-gate-text-secondary mb-10" data-id="element-25">
          Join thousands of developers getting better performance for less cost.
          <br data-id="element-26" />
          FPGAs for flexibility, ASICs for peak throughput — one API for both.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-27">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA3akOwONwkYJLK4nX5RaNw1wlVWWLd6dPKvH2FSMPjvA9IA/viewform" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 rounded-lg bg-gate-teal text-gate-dark font-bold text-lg hover:bg-gate-teal/90 transition-all shadow-[0_0_20px_-5px_rgba(0,212,170,0.5)]" data-id="element-28">
            Get Started Free
          </a>
          <a href="#" className="w-full sm:w-auto px-8 py-4 rounded-lg bg-gate-surface border border-gate-border text-white font-medium text-lg hover:bg-gate-surface/80 hover:border-gate-teal/50 transition-all flex items-center justify-center gap-2 group" data-id="element-29">
            Read the Docs
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-30" />
          </a>
        </div>
      </div>
    </div>;
}